import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from "@chakra-ui/react";
import { FunctionComponent } from "react";
import { DELETE_MODAL_SIZING, MODAL_SIZING } from "../../../utils/constants";

interface ConfirmModalProps {
    show: boolean;
    handleDelete: () => void;
    onClose: () => void;
    isDeletingEntity: boolean;
    bodyText: string;
}

export const ConfirmModal: FunctionComponent<ConfirmModalProps> = ({ show, handleDelete, onClose, isDeletingEntity, bodyText }) => {
    const confirmDelete = async () => {
        await handleDelete();
        onClose();
    };

    return (
        <Modal isOpen={show} onClose={onClose} size={MODAL_SIZING} isCentered motionPreset="slideInBottom">
            <ModalOverlay />
            <ModalContent style={{ ...DELETE_MODAL_SIZING }} overflowY="auto">
                <ModalHeader>Are you sure you want to delete?</ModalHeader>
                <ModalBody>{bodyText}</ModalBody>
                <ModalFooter>
                    <Button onClick={onClose} mr={3} variant="ghost">
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={confirmDelete} isLoading={isDeletingEntity} isDisabled={isDeletingEntity}>
                        Delete
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};
